import { skipToken, useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export function useFeature(id: number | null) {
  const { data: connectorData, refetch } = useSuspenseQuery(
    AdminAPI.integration.GET_FEATURE,
    id != null
      ? {
          variables: {
            id
          }
        }
      : skipToken
  )

  return {
    feature: getFragment(
      SharedAPI.integration.FEATURE_FRAGMENT,
      connectorData?.getIntegrationFeature
    ),
    refetch
  }
}
